/* eslint-disable no-unused-vars */
export const GET_MENU_BASIC_INFO = 'GET_MENU_BASIC_INFO'
export const GET_MENU_DETAIL = 'GET_MENU_DETAIL'
export const GET_PHOTO_GALLERY = 'GET_PHOTO_GALLERY'
export const GET_RECOMMEND_SERVICE = 'GET_RECOMMEND_SERVICE'
export const GET_MENU_STAY = 'GET_MENU_STAY'
export const ADD_VIEWED_LIST = 'ADD_VIEWED_LIST'
export const GET_COUPON_ITEM_DETAIL = 'GET_COUPON_ITEM_DETAIL'
export const GET_FACILITIES = 'GET_FACILITIES'
export const GET_SAME_CATEGORY_MENUS = 'GET_SAME_CATEGORY_MENUS'

import MenuApi from '../../../apis/menu'
import {
  SET_MENU_BASIC_INFO,
  SET_MENU_DETAIL 
} from './mutations'

export default {
  [GET_PHOTO_GALLERY]({ commit }, menuNo) {
    return MenuApi.getPhotoGallery(menuNo)
  },
  [GET_COUPON_ITEM_DETAIL]({ commit }, data) {
    return MenuApi.getCouponDetail2()
  },
  [GET_MENU_BASIC_INFO]({ commit }, data) {
    return MenuApi.getMenuBasicInfo(data?.menuNo).then(
      (result) => {
        return result
      }
    )
  },
  [GET_MENU_DETAIL]({ commit }, data) {
    return MenuApi.getMenuDetail(data?.menuNo, data?.planId, data?.roomId, data?.companyCd).then(
      (result) => {
        return result
      }
    )
  },
  [GET_MENU_STAY]({ commit }, data) {
    return MenuApi.getMenuStay(data.menuNo)
  },
  [GET_RECOMMEND_SERVICE]({ commit }, data) {
    return MenuApi.getRecommendServices(data.menuNo)
  },
  [ADD_VIEWED_LIST]({ commit }, data) {
    return MenuApi.addInListHistory(data.menuNo, data.serviceType)
  },
  [GET_FACILITIES]({ commit }, data) {
    return MenuApi.getFacilities(data)
  },
  [GET_SAME_CATEGORY_MENUS]({ commit }, data) {
    console.log('<><><>><>< GET_SAME_CATEGORY_MENUS ', data)
    return MenuApi.getSameCategoryMenus(data)
  }
}